import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator, ValidationResult } from '../cell-validators'
import { machineHasStampRoller } from '../machine-has-stamp-roller'
import { validateDurstAndGf } from './durst-and-gf-validator'

const createErrorResult = (token: GlobalToken): ValidationResult => ({
    message: 'Станок не подходит под вал штампа',
    bgColor: token.colorErrorBg,
    color: token.colorErrorText || token.colorError,
})

export const validateMachine: CellValidator = (record, token) => {
    if (!record.machine || !record.stamp?.roller?.documentId) {
        return null
    }

    if (!machineHasStampRoller(record.machine, record)) {
        return createErrorResult(token)
    }

    const durstAndGfResult = validateDurstAndGf(record, token)

    if (durstAndGfResult) {
        return durstAndGfResult
    }

    return null
}
